import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Toast } from 'antd-mobile/lib';
import { hashHistory } from 'react-router';
import Util from '../../util.js';

import { getQueryTradeRecords } from '../../action/investmentAction';
import NavigatorMain from '../NavigatorMain';

/*操作记录*/
class OperationRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount(){
    document.getElementsByTagName('title')[0].innerHTML = "操作记录";
    let superFundCode = this.props.location.state.superFundCode;
    let { dispatch } = this.props;
    let data = { 
      superFundCode:superFundCode,
      pageIndex:1,
      pageSize:999,
    }
    dispatch(getQueryTradeRecords(data,this.callBack.bind(this),this))
  }
  callBack(data){
    console.log(data)
  }
  goBack(){
    hashHistory.goBack();
  }
            
  render() {
    let superFundCode = this.props.location.state.superFundCode;
    let data = this.props.QueryTradeRecords ? this.props.QueryTradeRecords : [];

    return (
        <div className="container">
          <NavigatorMain>
          <div className="header black">
            <div ><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div >操作记录</div>
            <div ></div>    
          </div>
          </NavigatorMain>
          <div className='content' >
          {
            data.map((item,i)=>{
              return(
                <div className="superListJ superOperation" key = { i }>
                  <div style={{ borderBottom:'1px solid #f2f4f7'}}>
                    <span style={{ color:'#fa063a'}}>
                      { item.businessTypeName }
                    </span>
                    <span></span>
                  </div>
                  <div><span>{ item.fundName }</span><span>{ Util.fomatFloat(item.applicationAmount) + "元" }</span></div>
                  <div><span>{ item.businessStateName }</span><span>{  Util.formatStr(item.businessTime) }</span></div>
                </div>
              )
            })
          }

          {/*
          <div className="superListJ superOperation">
            <div style={{ borderBottom:'1px solid #f2f4f7'}}><span style={{ color:'#fa063a'}}>华夏智投银行卡申购</span><span></span></div>
            <div><span>常青藤大学组合</span><span>1000.00元</span></div>
            <div><span>成功</span><span>2017-07-12 17:13:30</span></div>
          </div>

          <div className="superListJ superOperation">
            <div style={{ borderBottom:'1px solid #f2f4f7'}}><span style={{ color:'#fa063a'}}>华夏智投银行卡申购</span><span></span></div>
            <div><span>常青藤大学组合</span><span>1000.00元</span></div>
            <div><span>成功</span><span>2017-07-12 17:13:30</span></div>
          </div>
          */}
          </div>
        </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
     QueryTradeRecords:state.QueryTradeRecords,
  }
}

export default connect(mapStateToProps)(OperationRecord);





// WEBPACK FOOTER //
// ./src/components/fundDetail/OperationRecord.js